"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleProjectList = exports.handleList = exports.handleCurrent = exports.initialState = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const currentReducer = require("./current");
const listReducer = require("./list");
const projectListReducer = require("./projectList");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
exports.initialState = {
    current: Object.assign({}, currentReducer.initialState),
    list: Object.assign({}, listReducer.initialState),
    projectList: Object.assign({}, listReducer.initialState)
};
const currentLens = monocle.Lens.fromProp('current');
const listLens = monocle.Lens.fromProp('list');
const projectListLens = monocle.Lens.fromProp('projectList');
// List
const handleCurrent = (action) => (state) => {
    const fn = currentReducer.methods[action.type];
    if (fn) {
        const current = currentLens.get(state);
        return currentLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleCurrent = handleCurrent;
// List
const handleList = (action) => (state) => {
    const fn = listReducer.methods[action.type];
    if (fn) {
        if (action.project !== undefined) {
            return state;
        }
        const list = listLens.get(state);
        return listLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleList = handleList;
// List
const handleProjectList = (action) => (state) => {
    const fn = projectListReducer.methods[action.type];
    if (fn) {
        if (action.project === undefined) {
            return state;
        }
        const list = projectListLens.get(state);
        return projectListLens.set(fn(list, action))(state);
    }
    return state;
};
exports.handleProjectList = handleProjectList;
// Reducer
exports.default = (state = Object.assign({}, exports.initialState), action) => {
    return fp.function.compose((0, exports.handleCurrent)(action), (0, exports.handleProjectList)(action), (0, exports.handleList)(action))(state);
};
//#endregion
//# sourceMappingURL=index.js.map